import NotificationItem from "./NotificationItem";

import { Skeleton } from "@/components/ui/skeleton";
import { Notification } from "@/queries/notifications/useNotifications";

interface NotificationListProps {
  notifications: Notification[];
  onDismiss: (id: number) => void;
  observerTarget: React.RefObject<HTMLDivElement>;
  isFetchingNextPage: boolean;
  hasNextPage?: boolean;
}

const LoadingSkeleton = () => (
  <div className="flex items-start gap-3 border-b border-gray-100/50 px-3 py-3 last:border-b-0 dark:border-gray-800/50">
    <div className="mt-1.5 flex-shrink-0">
      <div className="h-1.5 w-1.5 animate-pulse rounded-full bg-gray-200 dark:bg-gray-700" />
    </div>
    <div className="min-w-0 flex-1 space-y-2">
      <Skeleton width="90%" height={14} />
      <Skeleton width="75%" height={14} />
      <Skeleton width="30%" height={10} />
    </div>
  </div>
);

const NotificationsList = ({
  notifications,
  onDismiss,
  observerTarget,
  isFetchingNextPage,
  hasNextPage,
}: NotificationListProps) => (
  <>
    {notifications.map(notification => (
      <NotificationItem key={notification.id} {...notification} onDismiss={onDismiss} />
    ))}

    {isFetchingNextPage && (
      <>
        <LoadingSkeleton />
        <LoadingSkeleton />
      </>
    )}

    {hasNextPage && !isFetchingNextPage && <div ref={observerTarget} className="h-1" />}
  </>
);

export default NotificationsList;
